module.exports = __webpack_public_path__ + "assets/splash-screen-3.382691aa.svg";